/* Nune · extra virgin coconut oil page (EVC)
   Behaviour for the sections named NN-evc-*.liquid. Loaded by snippets/evc-head.liquid.
   Every evc section includes that snippet, so this file can be executed more than once:
   it sets itself up the first time and only re-scans the page after that. */
(function () {
  if (window.NuneEVC) { window.NuneEVC.init(document); return; }

  var de = document.documentElement;
  // Width of the page scrollbar, so the full-width sections never cause sideways scrolling.
  function scrollbar() { de.style.setProperty('--nj-sb', (window.innerWidth - de.clientWidth) + 'px'); }
  scrollbar();
  window.addEventListener('resize', scrollbar);

  var FRAMES = 24, LOOP = 4800; // the jar sprite: 24 frames in a 12 x 2 grid, one turn every 4.8 s

  var setup = {
    // 01 hero: drag (or use the arrows) to turn the jar; it carries on spinning after a pause.
    hero: function (root) {
      var spin = root.querySelector('.nj-spin');
      if (!spin) return;
      var t0 = performance.now(), frame = 0, manual = false, drag = null, timer;
      function pos(f) { return ((f % 12) * 100 / 11).toFixed(4) + '% ' + (Math.floor(f / 12) * 100) + '%'; }
      function current() { return manual ? frame : Math.floor(((performance.now() - t0) / LOOP) * FRAMES) % FRAMES; }
      function show(f) { frame = ((f % FRAMES) + FRAMES) % FRAMES; spin.style.backgroundPosition = pos(frame); }
      function stop() { var f = current(); manual = true; spin.classList.remove('nj-spin--auto'); show(f); clearTimeout(timer); }
      function resume() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          t0 = performance.now() - frame / FRAMES * LOOP;
          spin.style.animationDelay = '-' + (frame / FRAMES * LOOP / 1000).toFixed(2) + 's';
          manual = false;
          spin.classList.add('nj-spin--auto');
        }, 2200);
      }
      spin.addEventListener('pointerdown', function (e) {
        stop(); drag = { x: e.clientX, f: frame };
        try { spin.setPointerCapture(e.pointerId); } catch (err) {}
        spin.classList.add('is-drag');
      });
      spin.addEventListener('pointermove', function (e) { if (drag) show(drag.f - Math.round((e.clientX - drag.x) / 16)); });
      function up() { if (!drag) return; drag = null; spin.classList.remove('is-drag'); resume(); }
      spin.addEventListener('pointerup', up);
      spin.addEventListener('pointercancel', up);
      root.querySelectorAll('[data-turn]').forEach(function (b) {
        b.addEventListener('click', function () { stop(); show(frame + Number(b.getAttribute('data-turn'))); resume(); });
      });
    },

    // 02 buy box: photo thumbnails, and pack choice updates the total and the Buy it now link.
    buy: function (root) {
      var slides = root.querySelectorAll('[data-slide]'), cap = root.querySelector('[data-cap]');
      root.querySelectorAll('[data-go]').forEach(function (b, i, all) {
        b.addEventListener('click', function () {
          slides.forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-slide') === b.getAttribute('data-go')); });
          all.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          if (cap) cap.textContent = b.getAttribute('data-cap');
        });
      });
      var total = root.querySelector('[data-total]'), buy = root.querySelector('[data-buynow]');
      root.querySelectorAll('.nj-pack input').forEach(function (r) {
        r.addEventListener('change', function () {
          var lab = r.closest('.nj-pack');
          if (total) total.textContent = lab.getAttribute('data-total');
          if (buy) buy.href = buy.getAttribute('data-base') + r.value;
        });
      });
    },

    // 04 melt slider: crossfades the set jar into the melted one and warms the background.
    melt: function (root) {
      var r = root.querySelector('input[type=range]'), deg = root.querySelector('[data-deg]'), line = root.querySelector('[data-line]'),
        st = root.querySelector('[data-stage]'), mel = root.querySelector('[data-melted]'), alt = root.querySelector('[data-alt]');
      if (!r) return;
      var lines = {
        cold: root.getAttribute('data-line-cold'), soft: root.getAttribute('data-line-soft'),
        melt: root.getAttribute('data-line-melt'), hot: root.getAttribute('data-line-hot')
      };
      function mix(a, b, k) {
        k = Math.max(0, Math.min(1, k));
        return '#' + [0, 2, 4].map(function (i) {
          return Math.round(parseInt(a.substr(i, 2), 16) * (1 - k) + parseInt(b.substr(i, 2), 16) * k).toString(16).padStart(2, '0');
        }).join('');
      }
      function update() {
        var t = Number(r.value), state = t < 22 ? 'cold' : t < 25 ? 'soft' : t < 27 ? 'melt' : 'hot';
        var words = { cold: 'set solid', soft: 'softening', melt: 'melting', hot: 'fully melted' };
        deg.textContent = t + '°C';
        r.setAttribute('aria-valuetext', t + ' degrees, ' + words[state]);
        mel.style.opacity = Math.max(0, Math.min(1, (t - 21) / 5)).toFixed(2);
        st.style.background = mix('E3ECEC', 'F6E2B4', (t - 16) / 20);
        st.classList.toggle('is-hot', t >= 27);
        if (lines[state]) line.textContent = lines[state];
        alt.textContent = t < 22 ? 'The jar with the oil set solid and white' : 'The jar with the oil melted clear';
      }
      r.addEventListener('input', update);
      update();
    },

    // 07 crack the coconut: tap to open, tap again to put it back.
    crack: function (root) {
      var b = root.querySelector('[data-crack]'), pill = root.querySelector('[data-pill]'), line = root.querySelector('[data-line]'), n = 0;
      if (!b) return;
      function text(name) { return root.getAttribute('data-' + name) || ''; }
      b.addEventListener('click', function () {
        var open = !root.classList.contains('is-open');
        if (open) { n++; root.classList.remove('is-open'); void root.offsetWidth; }
        root.classList.toggle('is-open', open);
        pill.textContent = open ? text('pill-open') : text('pill-closed');
        b.setAttribute('aria-label', open ? 'Put the coconut back together' : 'Crack the coconut open');
        line.textContent = open ? (n > 2 && text('line-many') ? text('line-many').replace('[n]', n) : text('line-open')) : text('line-idle');
      });
    },

    // 05 + 06 pinned sections: fall back to a normal layout if a theme wrapper would stop "sticky" working.
    pin: function (root) {
      var el = root;
      while ((el = el.parentElement) && el !== document.body) {
        var cs = getComputedStyle(el);
        if (/(hidden|auto|scroll)/.test(cs.overflowX + ' ' + cs.overflowY)) { root.classList.add('nj-nopin'); return; }
      }
    },

    // 11 sticky add to cart: shown when none of the page's Add to basket forms is on screen
    // (and the first one has been scrolled past); hidden again when one comes into view.
    sticky: function (root) {
      var bar = root.querySelector('.nj-sticky__bar'), queued = false;
      function forms() {
        return Array.prototype.filter.call(document.querySelectorAll('[data-evc-atc]'), function (f) { return !root.contains(f); });
      }
      function update() {
        queued = false;
        var list = forms(), vh = window.innerHeight, show;
        if (list.length) {
          var anyInView = list.some(function (f) { var r = f.getBoundingClientRect(); return r.bottom > 0 && r.top < vh && r.height > 0; });
          var first = list[0].getBoundingClientRect();
          show = !anyInView && first.bottom < 0;
        } else {
          show = window.scrollY > 600;
        }
        if (root.hasAttribute('data-evc-force')) show = true;
        root.classList.toggle('is-visible', show);
        var shown = show && getComputedStyle(root).display !== 'none';
        de.style.setProperty('--nj-sticky-h', (shown ? bar.offsetHeight : 0) + 'px');
        de.classList.toggle('nj-sticky-on', shown);
      }
      function queue() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      root._njUpdate = update;
      update();
    }
  };

  // ---------------------------------------------------------------- add to cart without leaving the page
  // Every evc Add to basket form (data-evc-ajax) is sent in the background. When the theme has a
  // Dawn-style cart drawer (<cart-drawer> or <cart-notification>), it is refreshed and opened like on the
  // theme's own product pages; otherwise a small message with a link to the cart is shown. If anything
  // fails before the request is made, the form simply submits the normal way.
  function toastEl() {
    var t = document.querySelector('[data-evc-toast]');
    if (!t) {
      t = document.createElement('div');
      t.className = 'nj-toast nj-toast--solo';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.hidden = true;
      var wrap = document.createElement('div');
      wrap.className = 'nj nj-toast-host';
      wrap.appendChild(t);
      document.body.appendChild(wrap);
    }
    return t;
  }
  var toastTimer;
  function toast(message, isError) {
    var t = toastEl();
    t.textContent = '';
    t.classList.toggle('is-error', !!isError);
    var span = document.createElement('span');
    span.textContent = message;
    t.appendChild(span);
    if (!isError) {
      var a = document.createElement('a');
      a.href = t.getAttribute('data-cart-url') || (window.routes && window.routes.cart_url) || '/cart';
      a.textContent = t.getAttribute('data-view') || 'View cart';
      t.appendChild(a);
    }
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, isError ? 6000 : 4000);
  }
  function themeCart() {
    var c = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    return c && typeof c.renderContents === 'function' ? c : null;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-evc-ajax') || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var button = form.querySelector('[type=submit]');
    if (button && button.getAttribute('aria-busy') === 'true') return;
    var cart = themeCart(), body = new FormData(form);
    try {
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        body.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
    } catch (err) { cart = null; body = new FormData(form); }
    if (button) { button.setAttribute('aria-busy', 'true'); button.classList.add('is-loading'); }
    fetch(form.getAttribute('action') || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(res.description || res.message || 'Sorry, that could not be added.', true); return; }
        // tell the rest of the theme the cart changed (Dawn-style themes listen for this)
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: body.get('id'), cartData: res });
          }
        } catch (err) {}
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var opened = false;
        if (cart && res.sections) {
          try { cart.renderContents(res); opened = true; } catch (err) { opened = false; }
        }
        if (!opened) toast((toastEl().getAttribute('data-added')) || 'Added to your cart.');
      })
      .catch(function () { toast('Sorry, something went wrong. Please try again.', true); })
      .then(function () { if (button) { button.removeAttribute('aria-busy'); button.classList.remove('is-loading'); } });
  });

  function init(scope) {
    var list = [];
    if (scope.matches && scope.matches('[data-evc]')) list.push(scope);
    scope.querySelectorAll('[data-evc]').forEach(function (el) { list.push(el); });
    list.forEach(function (el) {
      if (el.hasAttribute('data-evc-ready')) return;
      el.setAttribute('data-evc-ready', '');
      el.getAttribute('data-evc').split(' ').forEach(function (name) {
        if (!setup[name]) return;
        try { setup[name](el); } catch (err) { if (window.console) console.error('[Nune EVC] ' + name, err); }
      });
    });
  }

  window.NuneEVC = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Theme editor: set up sections again when they are added or re-rendered,
  // and show the matching photo when a gallery block is selected in the sidebar.
  document.addEventListener('shopify:section:load', function (e) { scrollbar(); init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-go]')) e.target.click();
  });
  // keep the sticky bar on screen while its section is selected, so it can be edited
  function forceSticky(e, on) {
    var bar = e.target && e.target.querySelector && e.target.querySelector('[data-evc="sticky"]');
    if (!bar) return;
    if (on) bar.setAttribute('data-evc-force', ''); else bar.removeAttribute('data-evc-force');
    if (bar._njUpdate) bar._njUpdate();
  }
  document.addEventListener('shopify:section:select', function (e) { forceSticky(e, true); });
  document.addEventListener('shopify:section:deselect', function (e) { forceSticky(e, false); });
})();
